import React from 'react'
import { useLogon } from '@core/Utils/hooks'

declare global {
  interface Window {
    _qualtrics?: {
      betData?: {
        category: 'sports' | 'racing'
        incentive: 'special' | 'bonus'
        stake: number
        betType: string
        code: string
      }
    }
    QSI?: {
      config: {
        externalReference: number | null
      }
    }
  }
}

export const setQualtricsBetData = (
  category: 'sports' | 'racing',
  incentive: 'special' | 'bonus',
  stake = 0,
  betType = '',
  code = ''
) => {
  window._qualtrics = window._qualtrics || {}
  window._qualtrics.betData = {
    category: category,
    incentive,
    stake,
    betType,
    code,
  }
}

export const useQualtricsExternalReferenceManager = () => {
  const { accountNumber } = useLogon()

  // Keep externalReference in sync with the current account number.
  React.useEffect(() => {
    if (!window.QSI) {
      window.QSI = {
        config: {
          externalReference: null,
        },
      }
    }

    window.QSI.config.externalReference = accountNumber
  }, [accountNumber])
}
